export interface InsuranceUnion {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy?: unknown;
  ownerList?: unknown;
  effectiveFrom: string;
  description: string;
  nativeDescription: string;
  orgId: number;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface InsuranceUnionListRequest {
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}

export interface InsuranceUnionCreateRequest {
  effectiveFrom: string;
  description: string;
  nativeDescription: string;
  status: number;
  insuranceUnionRateDeductions: InsuranceUnionRateDeduction[];
}

interface InsuranceUnionRateDeduction {
  deductionId: string;
  type: number;
  rate: number;
  status: number;
}

export interface InsuranceUnionDetail {
  id: string;
  description: string;
  nativeDescription: string;
  effectiveFrom: string;
  status: number;
  insuranceUnionRateDeductions: InsuranceUnionRateDeductionDetail[];
}

interface InsuranceUnionRateDeductionDetail {
  id: string;
  rate: string;
  type: number;
  deduction: Deduction;
}

interface Deduction {
  id: string;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
}

export interface InsuranceUnionUpdateRequest
  extends InsuranceUnionCreateRequest {
  id: string;
}

export interface InsuranceUnionListResponse extends RestAPIMetaResponse {
  items: Array<InsuranceUnion>;
}

export enum InsuranceUnionType {
  Company = 1,
  Employee = 3,
}
